import { useAtomValue } from 'jotai';
import { Spinner, useMedia, XStack, YStack } from 'smoothie';

import { MemberInfo } from '../../../member/components/MemberInfo';
import { adminUserAtom, selectedMembershipAtom } from '../../entityAtoms';
import { MembershipDetailsTabs } from './MembershipDetailsTabs';
import { MembershipGuidanceNotesModal } from './MembershipGuidanceNotesModal';
import { MembershipInfo } from './MembershipInfo';
import {
    MembershipMessagingModal,
    MembershipMessagingPanel,
    membershipMessagingViewModeAtom,
} from './MembershipMessaging';
import { MembershipPageHeader } from './MembershipPageHeader';

export const MembershipDetailsPage = ({
    membershipId,
}: {
    membershipId: string;
}) => {
    const adminUser = useAtomValue(adminUserAtom);
    const selectedMembership = useAtomValue(selectedMembershipAtom);
    const messagingViewMode = useAtomValue(membershipMessagingViewModeAtom);
    const breakpoints = useMedia();

    // TODO some of this logic may not be needed if we update selectedMembership state on
    // [id] page or whenever selectedMembershipIdAtom changes
    const isLoading = selectedMembership?.id !== membershipId;

    const membershipDetails = isLoading ? null : selectedMembership;

    const canShowMembershipDetails =
        adminUser.authorization.selectedMembership.general.canView;

    const canShowGuideMessaging =
        membershipDetails !== null &&
        adminUser.authorization.guideMessaging.canUse &&
        membershipDetails.guide?.sendbirdUserId != null &&
        membershipDetails.guide.sendbirdUserId ===
            adminUser.guide?.sendbirdUserId;

    const enableMessagingPanel =
        canShowGuideMessaging &&
        breakpoints.lg &&
        messagingViewMode === 'panel';
    const enableMessagingModal = canShowGuideMessaging && !enableMessagingPanel;

    return (
        <>
            <YStack width="94%" marginVertical="3vh">
                <MembershipPageHeader
                    membershipDetails={membershipDetails}
                    showMessagingButton={enableMessagingModal}
                />
                <XStack width="100%">
                    <MemberInfo
                        flex={1}
                        members={membershipDetails?.users ?? []}
                    />
                    <MembershipInfo
                        flex={1}
                        membershipDetails={membershipDetails}
                    />
                </XStack>
                {canShowMembershipDetails && (
                    <XStack width="100%">
                        <MembershipDetailsTabs
                            flex={1}
                            membershipDetails={membershipDetails}
                        />
                        {enableMessagingPanel && (
                            <MembershipMessagingPanel
                                flex={1}
                                membership={membershipDetails}
                            />
                        )}
                        {enableMessagingModal && (
                            <MembershipMessagingModal
                                membership={membershipDetails}
                            />
                        )}
                    </XStack>
                )}
            </YStack>
            {canShowMembershipDetails && (
                <MembershipGuidanceNotesModal membershipId={membershipId} />
            )}
            {isLoading && (
                <YStack // TODO maybe update Smoothie FullScreenSpinner to have a translucent option
                    position="absolute"
                    top={0}
                    width="100%"
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="rgba(255, 255, 255, 0.5)"
                >
                    <Spinner />
                </YStack>
            )}
        </>
    );
};
